import {Selector} from 'x.vue.components.ui';
import {CalculatorWoods_, board} from './mixins.js';
import {Walls} from './walls.js';
import './cw.css';

export const CalculatorWoods_eurvagon = {
    mixins: [CalculatorWoods_, board],
    components: {selector: Selector, walls: Walls},
    data () {
        return {
            config: {
                steps: 2
            },
            build: {},
            vars: {
                
                boards: {
                    p1: {'title': 'Евровагонка 12,5 х 96 х 2000',H:0.096,L:2},
                    p2: {'title': 'Евровагонка 12,5 х 96 х 2500',H:0.096,L:2.5},
                    p3: {'title': 'Евровагонка 12,5 х 96 х 2700',H:0.096,L:2.7},
                    p4: {'title': 'Евровагонка 12,5 х 96 х 3000',H:0.096,L:3},
                    p5: {'title': 'Имитация бруса (Хвоя) 20 х 146 х 3000',H:0.146,L:3},
                    p6: {'title': 'Имитация бруса (Кедр) 26 х 146 х 3000',H:0.146,L:3},
                    p7: {'title': 'Имитация бруса (Кедр) 28 х 146 х 3000',H:0.146,L:3},
                    p8: {'title': 'Блокхаус (Хвоя) 28 х 146 х 3000',H:0.146,L:3},
                    p9: {'title': 'Панель штиль (Хвоя) 12,5 х 96 х 2000',H:0.096,L:2},
                    p10: {'title': 'Панель штиль (Хвоя) 12,5 х 96 х 3000',H:0.096,L:3},
                    p11: {'title': 'Панель штиль (Хвоя) 14 х 146 х 2000',H:0.146,L:2},
                    p12: {'title': 'Панель штиль (Хвоя) 14 х 146 х 3000',H:0.146,L:3},
                    p13: {'title': 'Панель штиль (Лиственница) 12,5 х 96 х 2000',H:0.096,L:2},
                    p14: {'title': 'Панель штиль (Лиственница) 12,5 х 96 х 3000',H:0.096,L:3},
                    p15: {'title': 'Панель штиль (Лиственница) 14 х 96 х 2000',H:0.096,L:2},
                    p16: {'title': 'Панель штиль (Лиственница) 14 х 96 х 3000',H:0.096,L:3},
                    p17: {'title': 'Панель штиль (Лиственница) 14 х 141 х 2000',H:0.141,L:2},
                    p18: {'title': 'Панель штиль (Лиственница) 14 х 141 х 3000',H:0.141,L:3},
                    p19: {'title': 'Панель штиль (Кедр) 12,5 х 96 х 2000',H:0.096,L:2},
                    p20: {'title': 'Панель штиль (Кедр) 12,5 х 96 х 3000',H:0.096,L:3},
                    p21: {'title': 'Панель штиль (Кедр) 14 х 96 х 2000',H:0.096,L:2},
                    p22: {'title': 'Панель штиль (Кедр) 14 х 96 х 3000',H:0.096,L:3},
                    p23: {'title': 'Панель штиль (Кедр) 14 х 141 х 2000',H:0.141,L:2},
                    p24: {'title': 'Панель штиль (Кедр) 14 х 141 х 3000',H:0.141,L:3},
                },
            },
            form: {},
        }
    },
    created () {
        this.form.gap = this.form.gap || 5;
    },
    computed: {
        K () {
            return 1.1
        },
        Z () {
            let Z = parseInt(this.form.gap)/1000;
            return Z||0;
        },
        N () {
            let N = 0;
            if (this.build?.S) {
                let devision = (this.bH+this.Z)*this.bL;
                N = this.build.S*this.K / devision;
            }
            
            return N;
        },
        result () {
            let result = {
                    rows: [],
                    errors: [],
                    total: 0
                };
            // площадь поверхностей
            if (this.build.S) {
                result.rows.push({
                        'title': 'Площадь поверхностей',
                        'value': this.build.S,
                    });
            } else {
                result.errors.push({
                        'text': 'Укажите площадь стен и проемов',
                        'step': 1,
                    });
            }
            
            // материал и зазоры
            if (this.board) {
                result.rows.push({
                        'title': 'Материал покрытия',
                        'value': this.board.title,
                    });
            } else {
                result.errors.push({
                        'text': 'Выбирите материал покрытий',
                        'step': 2,
                    });
            }
            if (this.form.gap) {
                result.rows.push({
                        'title': 'Зазор между досками',
                        'value': this.form.gap,
                    });
            } else {
                result.errors.push({
                        'text': 'Укажите зазор',
                        'step': 2,
                    });
            }
            
            ///////////////////////// результат
            result.total = Math.ceil(this.N);
            
            return result;
        }
    },/// ВЫНЕСТИ В МЕКСИН С ПЛАНКЕНОМ!
	template: `
	<div>
        <div class="tn-cw-step"
                v-if="view != 'wide' || step == 1"
            >
            <a v-bind:name="'step'+(1+stepg-step)"></a>
            <div class="calculator__info">
                
                <div class="calculator__step">
                    <strong v-if="view == 'wide'">Шаг {{stepg}}</strong>
                    <span>Стены</span>
                </div>
            </div>
            <keep-alive>
            <walls
                    v-model="build"
                ></walls>
            </keep-alive>
        </div>
        
        <div class="tn-cw-step"
                v-if="view != 'wide' || step == 2"
            >
            <a v-bind:name="'step'+(2+stepg-step)"></a>
            <div class="calculator__info">
                
                <div class="calculator__step">
                    <strong v-if="view == 'wide'">Шаг {{stepg}}</strong>
                    <span>Покрытие</span>
                </div>
            </div>
            <div class="params params--coating">
                <label class="params-select">
                    Материал настила:
                    <selector v-model="form.board"
                            v-bind:options="vars.boards"
                            titlekey="title"
                            placeholder="Выбирите материал"
                        />
                </label>

                <div>
                    <span class="params-name">Зазоры между досками:</span>
                    <div class="params-radio">
                        <label class="params-radio-label">
                            <input type="radio" name="gap" v-model="form.gap" value="5">
                            <span class="params-choice">
                                <i></i>
                                <span> 5 мм</span>
                            </span>
                        </label>
                        <label class="params-radio-label">
                            <input type="radio" name="gap" v-model="form.gap" value="8">
                            <span class="params-choice">
                                <i></i>
                                <span> 8 мм</span>
                            </span>
                        </label>
                    </div>
                </div>
                
            </div>
            
        </div>
        
    </div>
	`
}